// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BUUO","newExpiryDate":"styles_newExpiryDate__3gQbM","footer":"styles_footer__W1Yi0"};